import {
  START_LOAD_OJ,
  SUCCESS_LOAD_OJ,
  ERROR_LOAD_OJ,
  DATE_CHANGE_FILTER_OJ,
  MULTI_SELECT_CHANGE_FILTER_OJ,
  APPLY_FILTER_OJ,
  CLEAR_FILTER_OJ,
  SET_PAGINATION_OJ,
  SET_SORTING_OJ,
  CLEAR_OJ_ITEM,
  SELECT_CHANGE_PLANT_OJ,
  START_LOAD_OJ_ITEM,
  SUCCESS_LOAD_OJ_ITEM,
  ERROR_LOAD_OJ_ITEM,
  START_CREATE_OJ_ITEM,
  SUCCESS_CREATE_OJ_ITEM,
  ERROR_CREATE_OJ_ITEM,
  START_UPDATE_OJ_ITEM,
  SUCCESS_UPDATE_OJ_ITEM,
  ERROR_UPDATE_OJ_ITEM,
  START_LOAD_FILTER_OPTIONS_OJ,
  SUCCESS_LOAD_FILTER_OPTIONS_OJ,
  ERROR_LOAD_FILTER_OPTIONS_OJ,
  SUCCESS_LOAD_PLANT_OJ,
  START_LOAD_EQUIPMENTS_OJ,
  START_LOAD_RECORD_TYPES_OJ,
  SUCCESS_LOAD_RECORD_TYPES_OJ,
  SUCCESS_LOAD_EQUIPMENTS_OJ,
  START_CREATE_OJ_EQUIPMENT,
  SUCCESS_CREATE_OJ_EQUIPMENT,
  ERROR_CREATE_OJ_EQUIPMENT,
  SET_ERROR_CREATE_OJ_EQUIPMENT_DUPLICATE,
  CLEAR_ERROR_CREATE_OJ_EQUIPMENT_DUPLICATE,
  CLEAR_CREATED_EQUIPMENT_ID,
  START_LOAD_OJ_HISTORY,
  SUCCESS_LOAD_OJ_HISTORY,
  ERROR_LOAD_OJ_HISTORY,
  START_TOGGLE_IS_DEVIATION_OJ_ITEM,
  SUCCESS_TOGGLE_IS_DEVIATION_OJ_ITEM,
  ERROR_TOGGLE_IS_DEVIATION_OJ_ITEM,
  CLEAR_TOGGLED_IS_DEVIATION_OJ_ITEM,
  START_SENT_REQUEST_FOR_EDIT_OJ_ITEM,
  START_SEND_REQUEST_FOR_EDIT_OJ_ITEM,
  SUCCESS_SEND_REQUEST_FOR_EDIT_OJ_ITEM,
  ERROR_SEND_REQUEST_FOR_EDIT_OJ_ITEM,
  START_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM,
  SUCCESS_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM,
  ERROR_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM,
  START_REJECT_REQUEST_FOR_EDIT_OJ_ITEM,
  SUCCESS_REJECT_REQUEST_FOR_EDIT_OJ_ITEM,
  ERROR_REJECT_REQUEST_FOR_EDIT_OJ_ITEM,
} from 'store/actions/operationalJournal'
import {DEFAULT_OFFSET, DEFAULT_LIMIT} from 'constants/pagination'

import {mappingToAPI} from 'pages/OperationalJournal/utils'

const OPTIONS_KEY = 'id'

const DEFAULT_PAGINATION = {
  limit: DEFAULT_LIMIT,
  offset: DEFAULT_OFFSET,
}

const DEFAULT_SORT_TABLE = {
  sortOrder: undefined,
  sortBy: undefined,
}

const defaultFilter = {
  equipmentIds: [],
  recordTypeIds: [],
  createdByEmails: [],
  dateRange: {},
  equipmentOptions: [],
  recordTypeOptions: [],
  createdByOptions: [],
  isChangeFilter: false,
  isEmptyFilter: true,
}

const initialState = {
  dataTable: [],
  pagination: DEFAULT_PAGINATION,
  count: 0,
  lastUpdatedAt: '',
  sorting: DEFAULT_SORT_TABLE,
  filter: defaultFilter,
  plants: [],
  recordTypes: [],
  stationOJId: '',
  item: null,
  history: [],
  equipmentDictionaries: {
    refs: {
      voltageClasses: {},
      electricalSystems: {},
      equipmentTypes: {},
      electricalConnections: {},
      dispatchNames: {},
    },
    matrix: [],
  },

  isSuccessPlants: false,

  isLoadingRecordTypes: false,
  isLoadingEquipmentDictionaries: false,
  isLoadedEquipmentDictionaries: false,

  isLoadingTable: false,
  isLoadedTable: false,
  isErrorTable: false,

  isLoadingItem: false,
  isLoadedItem: false,
  isErrorItem: false,

  isUpdatingItem: false,
  isUpdatedItem: false,

  isTogglingDeviationItem: false,
  isToggledDeviationItem: false,

  isSendingEditRequest: false,
  isSentEditRequest: false,
  isAcceptingEditRequest: false,
  isRejectingEditRequest: false,

  isCreatingItem: false,
  isCreatedItem: false,

  isCreatingEquipment: false,
  createdEquipmentId: null,
  isErrorCreateEquipmentDuplicate: false,

  isLoadingHistory: false,
  isLoadedHistory: false,
  isErrorHistory: false,
}

const operationalJournal = (state = initialState, action) => {
  switch (action.type) {
    case START_LOAD_OJ: {
      return {
        ...state,
        isLoadingTable: true,
      }
    }
    case SUCCESS_LOAD_OJ: {
      return {
        ...state,
        dataTable: action.data?.items,
        count: action.data?.count,
        lastUpdatedAt: action.data?.lastUpdatedAt,
        isLoadingTable: false,
        isLoadedTable: true,
        isUpdatedItem: false,
        isCreatedItem: false,
      }
    }
    case SUCCESS_LOAD_PLANT_OJ: {
      const {plants = []} = action
      const savedStationId = localStorage.getItem('stationOJId')

      const stationOJId =
        savedStationId && plants.some(p => p.id === Number(savedStationId))
          ? savedStationId
          : plants.length > 0
          ? plants[0]?.id
          : ''

      return {
        ...state,
        plants,
        isSuccessPlants: true,
        stationOJId,
      }
    }
    case START_LOAD_RECORD_TYPES_OJ: {
      return {
        ...state,
        isLoadingRecordTypes: true,
      }
    }
    case SUCCESS_LOAD_RECORD_TYPES_OJ: {
      const {recordTypes = []} = action
      return {
        ...state,
        recordTypes,
        isLoadingRecordTypes: false,
      }
    }
    case START_LOAD_EQUIPMENTS_OJ: {
      return {
        ...state,
        isLoadingEquipmentDictionaries: true,
      }
    }
    case SUCCESS_LOAD_EQUIPMENTS_OJ: {
      const {equipmentDictionaries = {}} = action
      return {
        ...state,
        equipmentDictionaries,
        isLoadingEquipmentDictionaries: false,
        isLoadedEquipmentDictionaries: true,
      }
    }
    case SELECT_CHANGE_PLANT_OJ: {
      localStorage.setItem('stationOJId', String(action.data))
      return {
        ...state,
        pagination: DEFAULT_PAGINATION,
        filter: defaultFilter,
        stationOJId: action.data,
      }
    }
    case DATE_CHANGE_FILTER_OJ: {
      return {
        ...state,
        filter: {
          ...state.filter,
          dateRange: action.dateRange,
          isChangeFilter: true,
          isEmptyFilter: false,
        },
      }
    }
    case MULTI_SELECT_CHANGE_FILTER_OJ: {
      return {
        ...state,
        filter: {
          ...state.filter,
          [action.data.key]: mappingToAPI(action.data.items, OPTIONS_KEY),
          isChangeFilter: true,
          isEmptyFilter: false,
        },
      }
    }
    case CLEAR_FILTER_OJ: {
      return {
        ...state,
        pagination: DEFAULT_PAGINATION,
        filter: {
          ...defaultFilter,
          equipmentOptions: state.filter.equipmentOptions,
          recordTypeOptions: state.filter.recordTypeOptions,
          createdByOptions: state.filter.createdByOptions,
        },
      }
    }
    case APPLY_FILTER_OJ: {
      return {
        ...state,
        filter: {
          ...state.filter,
          isChangeFilter: false,
        },
        pagination: DEFAULT_PAGINATION,
        sorting: DEFAULT_SORT_TABLE,
      }
    }
    case ERROR_LOAD_OJ: {
      return {
        ...state,
        isLoadingTable: false,
        isLoadedTable: true,
        isErrorTable: true,
      }
    }
    case SET_PAGINATION_OJ: {
      return {
        ...state,
        pagination: action.data,
      }
    }
    case SET_SORTING_OJ: {
      return {
        ...state,
        sorting: action.data,
      }
    }
    case START_LOAD_OJ_ITEM: {
      return {
        ...state,
        isLoadingItem: true,
      }
    }
    case SUCCESS_LOAD_OJ_ITEM: {
      return {
        ...state,
        item: action.data,
        isLoadingItem: false,
        isLoadedItem: true,
        isUpdatedItem: false,
      }
    }
    case ERROR_LOAD_OJ_ITEM: {
      return {
        ...state,
        isLoadedItem: true,
        isErrorItem: true,
      }
    }
    case START_CREATE_OJ_ITEM: {
      return {
        ...state,
        isCreatingItem: true,
      }
    }
    case SUCCESS_CREATE_OJ_ITEM: {
      return {
        ...state,
        isCreatingItem: false,
        isCreatedItem: true,
      }
    }
    case ERROR_CREATE_OJ_ITEM: {
      return {
        ...state,
        isCreatedItem: false,
        isCreatingItem: false,
      }
    }
    case START_CREATE_OJ_EQUIPMENT: {
      return {
        ...state,
        isCreatingEquipment: true,
        createdEquipmentId: null,
      }
    }
    case SUCCESS_CREATE_OJ_EQUIPMENT: {
      return {
        ...state,
        isCreatingEquipment: false,
        createdEquipmentId: action.data,
      }
    }
    case ERROR_CREATE_OJ_EQUIPMENT: {
      return {
        ...state,
        isCreatingEquipment: false,
        createdEquipmentId: null,
      }
    }
    case SET_ERROR_CREATE_OJ_EQUIPMENT_DUPLICATE: {
      return {
        ...state,
        isCreatingEquipment: false,
        createdEquipmentId: null,
        isErrorCreateEquipmentDuplicate: true,
      }
    }
    case CLEAR_ERROR_CREATE_OJ_EQUIPMENT_DUPLICATE: {
      return {
        ...state,
        isErrorCreateEquipmentDuplicate: false,
      }
    }
    case CLEAR_CREATED_EQUIPMENT_ID: {
      return {
        ...state,
        createdEquipmentId: null,
      }
    }
    case START_UPDATE_OJ_ITEM: {
      return {
        ...state,
        isUpdatingItem: true,
      }
    }
    case SUCCESS_UPDATE_OJ_ITEM: {
      return {
        ...state,
        isUpdatingItem: false,
        isUpdatedItem: true,
      }
    }
    case ERROR_UPDATE_OJ_ITEM: {
      return {
        ...state,
        isUpdatedItem: false,
        isUpdatingItem: false,
      }
    }
    case START_TOGGLE_IS_DEVIATION_OJ_ITEM: {
      return {
        ...state,
        isTogglingDeviationItem: true,
        isToggledDeviationItem: false,
      }
    }
    case SUCCESS_TOGGLE_IS_DEVIATION_OJ_ITEM: {
      return {
        ...state,
        item: {
          ...state.item,
          isDeviation: action.data.isDeviation,
        },
        isTogglingDeviationItem: false,
        isToggledDeviationItem: true,
      }
    }
    case ERROR_TOGGLE_IS_DEVIATION_OJ_ITEM: {
      return {
        ...state,
        isTogglingDeviationItem: false,
        isToggledDeviationItem: false,
      }
    }
    case CLEAR_TOGGLED_IS_DEVIATION_OJ_ITEM: {
      return {
        ...state,
        isToggledDeviationItem: false,
      }
    }
    case START_SENT_REQUEST_FOR_EDIT_OJ_ITEM: {
      return {
        ...state,
        isSentEditRequest: false,
      }
    }
    case START_SEND_REQUEST_FOR_EDIT_OJ_ITEM: {
      return {
        ...state,
        isSendingEditRequest: true,
      }
    }
    case SUCCESS_SEND_REQUEST_FOR_EDIT_OJ_ITEM:
    case ERROR_SEND_REQUEST_FOR_EDIT_OJ_ITEM: {
      return {
        ...state,
        isSendingEditRequest: false,
        isSentEditRequest: true,
      }
    }
    case START_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM: {
      return {
        ...state,
        isAcceptingEditRequest: true,
      }
    }
    case SUCCESS_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM:
    case ERROR_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM: {
      return {
        ...state,
        isAcceptingEditRequest: false,
      }
    }

    case START_REJECT_REQUEST_FOR_EDIT_OJ_ITEM: {
      return {
        ...state,
        isRejectingEditRequest: true,
      }
    }
    case SUCCESS_REJECT_REQUEST_FOR_EDIT_OJ_ITEM:
    case ERROR_REJECT_REQUEST_FOR_EDIT_OJ_ITEM: {
      return {
        ...state,
        isRejectingEditRequest: false,
      }
    }

    case CLEAR_OJ_ITEM: {
      return {
        ...state,
        item: null,
      }
    }

    case START_LOAD_FILTER_OPTIONS_OJ: {
      return {
        ...state,
        isLoadingEquipment: true,
      }
    }
    case SUCCESS_LOAD_FILTER_OPTIONS_OJ: {
      const {data} = action
      return {
        ...state,
        filter: {
          ...state.filter,
          equipmentOptions: data.equipment,
          recordTypeOptions: data.recordType,
          createdByOptions: data.createdBy.map(({email, name}) => ({id: email, name})),
        },
      }
    }
    case ERROR_LOAD_FILTER_OPTIONS_OJ: {
      return {
        ...state,
      }
    }
    case START_LOAD_OJ_HISTORY: {
      return {
        ...state,
        isLoadingHistory: true,
        isLoadedHistory: false,
        isErrorHistory: false,
      }
    }
    case SUCCESS_LOAD_OJ_HISTORY: {
      return {
        ...state,
        history: action.data,
        isLoadingHistory: false,
        isLoadedHistory: true,
      }
    }
    case ERROR_LOAD_OJ_HISTORY: {
      return {
        ...state,
        isLoadingHistory: false,
        isErrorHistory: true,
      }
    }

    default:
      return state
  }
}

export default operationalJournal
